module.exports = __webpack_public_path__ + "assets/img/24_1073_big.fdb6997d.jpg";